(() => {
  if (window.UKRLanderBooted) return;
  window.UKRLanderBooted = true;
  class UKRLanderGroup {
    constructor(container) {
      this.container = container;
      this.productId = container.dataset.productId;
      this.productType = container.dataset.productType;
      this.productTitle = container.dataset.productTitle;
      this.groupTag = container.dataset.groupTag;
      this.products = [];
      this.init();
    }
    async init() {
      try {
        const options = await this.fetchProducts();
        if (this.products.length <= 1) { this.container.hidden = true; return; }
        this.render(options);
      } catch (error) {
        const message = document.createElement('p');
        message.textContent = this.container.dataset.errorLabel;
        message.setAttribute('role', 'status');
        this.container.replaceChildren(message);
        console.warn('Linked product options unavailable', error);
      }
    }
    async fetchProducts() {
      if (!this.groupTag) { this.products = []; return {}; }
      let cursor = null;
      let hasNext = true;
      const all = new Map();
      const seenCursors = new Set();
      while (hasNext) {
        const escapedTag = this.groupTag.replace(/['\\]/g, '\\$&');
        const query = `query GroupProducts($query: String!, $cursor: String) {
          products(first: 250, query: $query, after: $cursor) {
            pageInfo { hasNextPage endCursor }
            edges { node { id title handle tags } }
          }
        }`;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        let data;
        try {
          const response = await fetch('/api/graphql', {
            method: 'POST', signal: controller.signal,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json',
              'X-Shopify-Storefront-Access-Token': '9f8ac716aec31cfbe53256192f2152f1' },
            body: JSON.stringify({ query, variables: { query: `tag:'${escapedTag}'`, cursor } })
          });
          if (!response.ok) throw new Error(`Product lookup failed (${response.status})`);
          data = await response.json();
        } finally { clearTimeout(timer); }
        if (data.errors || !data.data?.products) throw new Error('Product lookup failed');
        const connection = data.data.products;
        connection.edges.forEach(edge => {
          if (edge.node.tags.includes(this.groupTag)) all.set(edge.node.id, edge);
        });
        hasNext = connection.pageInfo.hasNextPage;
        cursor = connection.pageInfo.endCursor;
        if (hasNext && (!cursor || seenCursors.has(cursor))) throw new Error('Invalid pagination cursor');
        seenCursors.add(cursor);
      }
      const filteredProducts = [...all.values()].map(edge => ({ node: {...edge.node, variants: {edges: []}} }));
            const options = {
                colors: new Set(),
                sizes: new Set(),
                panelTypes: new Set(),
                styles: new Set(),
                shapes: new Set(),
                magneticTowelBarStyles: new Set(),
                wattages: new Set(),
                columns: new Set(),
                controlTypes: new Set(),
                widths: new Set(),
                feetTypes: new Set(),
                plugTypes: new Set(),
                electricSizeWattages: new Set()
            };
            filteredProducts.forEach(edge => {
                const title = edge.node.title;
                let colorMasterMatch = title.match((window.colourRegexMiddle || /(?!) /));
                if (!colorMasterMatch) {
                    colorMasterMatch = title.match((window.colourRegexEnd || /(?!) /));
                }
                if (colorMasterMatch) {
                    options.colors.add(colorMasterMatch[1]);
                }
                const size = this.extractSizeFromTitle(title);
                if (size) {
                    options.sizes.add(size);
                }
                if (this.isElectricSizeWattageProduct()) {
                    const electricSizeWattage = this.extractElectricSizeWattageFromTitle(title);
                    if (electricSizeWattage) {
                        options.electricSizeWattages.add(electricSizeWattage);
                    }
                }
                const panelMatch = title.match(/(Single|Double) Panel/);
                if (panelMatch) {
                    options.panelTypes.add(panelMatch[1]);
                }
                if (this.productType === 'Ladder Towel Rails') {
                    const shapeMatch = title.match(/\b(Straight|Curved)\b/i);
                    if (shapeMatch) {
                        const shape = shapeMatch[1].charAt(0).toUpperCase() + shapeMatch[1].slice(1).toLowerCase();
                        options.shapes.add(shape);
                    }
                }
                if (this.productType === 'Valves') {
                    const styleMatch = title.match(/(corner|angled|straight)/i);
                    if (styleMatch) {
                        const style = styleMatch[1].charAt(0).toUpperCase() + styleMatch[1].slice(1).toLowerCase();
                        options.styles.add(style);
                    }
                }
                if (this.productType === 'Magnetic Towel Bars') {
                    if (title.includes('Square')) {
                        options.magneticTowelBarStyles.add('Square');
                    } else if (title.includes('Round')) {
                        options.magneticTowelBarStyles.add('Round');
                    }
                }
                if (this.productType === 'Elements') {
                    const wattageMatch = title.match(/(\d+)w/i);
                    if (wattageMatch) {
                        options.wattages.add(wattageMatch[1] + 'W');
                    }
                }
                if (this.productType === 'Column Feet') {
                    const columnMatch = title.match(/(\d+ Column)/i);
                    if (columnMatch) {
                        options.columns.add(columnMatch[1]);
                    }
                }
                if (title.includes('Thermostatic WIFI')) {
                    options.controlTypes.add('Thermostatic WIFI');
                } else if (title.includes('Thermostatic')) {
                    options.controlTypes.add('Thermostatic');
                } else if (title.includes('Standard')) {
                    options.controlTypes.add('Standard');
                }
                if (this.productType === 'Valves') {
                    const widthMatch = title.match(/(\d+)mm/);
                    if (widthMatch) {
                        options.widths.add(widthMatch[1] + 'mm');
                    }
                }
                const hasFeet =
                    title.includes('Feet Included') ||
                    (
                        this.productType === 'Cast Iron Column Radiators' &&
                        title.includes('Floor Standing')
                    );
                options.feetTypes.add(
                    hasFeet ? 'With Feet' : 'Without Feet'
                );
                if (title.includes('With Plug')) {
                    options.plugTypes.add('With Plug');
                } else {
                    options.plugTypes.add('Without Plug');
                }
            });

            options.sizes = new Set(
                [...options.sizes].sort((a, b) => {
                    const parseSize = (size) => {

                        const match = size.match(/(\d+)\s*x\s*(\d+)/);
                        if (match) {
                            return {
                                height: parseInt(match[1], 10),
                                width: parseInt(match[2], 10)
                            };
                        }

                        return {
                            height: parseInt(size, 10) || 0,
                            width: 0
                        };
                    };
                    const sizeA = parseSize(a);
                    const sizeB = parseSize(b);

                    if (sizeA.height !== sizeB.height) {
                        return sizeA.height - sizeB.height;
                    }

                    return sizeA.width - sizeB.width;
                })
            );
            this.products = filteredProducts.map(edge => ({
                ...edge.node,
                variants: edge.node.variants.edges.map(variantEdge => variantEdge.node)
            }));
            return options;
        }
        extractSizeFromTitle(title) {
            if (this.productType === 'Cast Iron Column Radiators') {
                return this.extractCastIronSizeFromTitle(title);
            }
            if (this.productType === 'Accessories' || this.productType === 'Pipe Covers') {
                const accessorySizeMatch = title.match(/(\d+)mm/);
                if (accessorySizeMatch) {
                    return accessorySizeMatch[1];
                }
            }
            const sizeMatch = title.match(/H(\d+)mm x W(\d+)mm/);
            if (sizeMatch) {
                return `${sizeMatch[1]} x ${sizeMatch[2]}`;
            }
            return null;
        }
        extractCastIronSizeFromTitle(title) {
            const sizeMatch = title.match(/H(\d+)mm x W(\d+)mm/i);
            if (!sizeMatch) {
                return null;
            }
            let height = parseInt(sizeMatch[1], 10);
            const width = sizeMatch[2];
            const hasFeet =
                title.includes('Feet Included') ||
                title.includes('Floor Standing');
            if (hasFeet) {
                if (title.includes('Emmeline III')) {
                    height -= 54;
                } else if (title.includes('Emmeline II')) {
                    height -= 57;
                } else if (title.includes('Emmeline I')) {
                    height -= 58;
                } else if (title.includes('Grace')) {
                    height -= 50;
                }
            }
            return `${height} x ${width}`;
        }
        extractWattageFromTitle(title) {
            const wattageMatch = title.match(/(\d+)w/i);
            return wattageMatch ? wattageMatch[1] + 'W' : null;
        }
        extractElectricSizeWattageFromTitle(title) {
            const size = this.extractSizeFromTitle(title);
            const wattageMatch = title.match(/(\d+)w/i);
            if (!size || !wattageMatch) return null;
            return `${size} (${wattageMatch[1]} Watts)`;
        }
        isElectricSizeWattageProduct() {
            return [
                'Electric Column Radiators',
                'Electric Designer Radiators'
            ].includes(this.productType);
        }
        sortSizeValues(values) {
            return [...values].sort((a, b) => {
                const parseValue = (value) => {
                    const sizeMatch = value.match(/(\d+)\s*x\s*(\d+)/i);
                    const wattMatch = value.match(/\((\d+)\s*Watts?\)/i);
                    return {
                        height: sizeMatch ? parseInt(sizeMatch[1], 10) : 0,
                        width: sizeMatch ? parseInt(sizeMatch[2], 10) : 0,
                        watts: wattMatch ? parseInt(wattMatch[1], 10) : 0
                    };
                };
                const sizeA = parseValue(a);
                const sizeB = parseValue(b);
                if (sizeA.height !== sizeB.height) {
                    return sizeA.height - sizeB.height;
                }
                if (sizeA.width !== sizeB.width) {
                    return sizeA.width - sizeB.width;
                }
                return sizeA.watts - sizeB.watts;
            });
        }
        findProductByOptions(optionType, value) {
            const currentTitle = this.productTitle;
            let currentColorMatch = currentTitle.match((window.colourRegexMiddle || /(?!) /));
            if (!currentColorMatch) {
                currentColorMatch = currentTitle.match((window.colourRegexEnd || /(?!) /));
            }
            const currentColor = currentColorMatch ? currentColorMatch[1] : null;
            const currentSize = this.extractSizeFromTitle(currentTitle);
            const currentElectricSizeWattage = this.isElectricSizeWattageProduct()
                ? this.extractElectricSizeWattageFromTitle(currentTitle)
                : null;
            const currentPanel = currentTitle.match(/(Single|Double) Panel/)?.[1];
            let currentShape = null;
            if (this.productType === 'Ladder Towel Rails') {
                const shapeMatch = currentTitle.match(/\b(Straight|Curved)\b/i);
                if (shapeMatch) {
                    currentShape = shapeMatch[1].charAt(0).toUpperCase() + shapeMatch[1].slice(1).toLowerCase();
                }
            }
            let currentStyle = null;
            if (this.productType === 'Valves') {
                const styleMatch = currentTitle.match(/(corner|angled|straight)/i);
                if (styleMatch) {
                    currentStyle = styleMatch[1].charAt(0).toUpperCase() + styleMatch[1].slice(1).toLowerCase();
                }
            }
            let currentMagneticTowelBarStyle = null;
            if (this.productType === 'Magnetic Towel Bars') {
                if (currentTitle.includes('Square')) {
                    currentMagneticTowelBarStyle = 'Square';
                } else if (currentTitle.includes('Round')) {
                    currentMagneticTowelBarStyle = 'Round';
                }
            }
            let currentWattage = null;
            if (this.productType === 'Elements') {
                const wattageMatch = currentTitle.match(/(\d+)w/i);
                if (wattageMatch) {
                    currentWattage = wattageMatch[1] + 'W';
                }
            }
            let currentColumn = null;
            if (this.productType === 'Column Feet') {
                const columnMatch = currentTitle.match(/(\d+ Column)/i);
                if (columnMatch) {
                    currentColumn = columnMatch[1];
                }
            }
            let currentControlType = null;
            if (currentTitle.includes('Thermostatic WIFI')) {
                currentControlType = 'Thermostatic WIFI';
            } else if (currentTitle.includes('Thermostatic')) {
                currentControlType = 'Thermostatic';
            } else if (currentTitle.includes('Standard')) {
                currentControlType = 'Standard';
            }
            let currentWidth = null;
            if (this.productType === 'Valves') {
                const widthMatch = currentTitle.match(/(\d+)mm/);
                if (widthMatch) {
                    currentWidth = widthMatch[1] + 'mm';
                }
            }
            const currentHasFeet =
                currentTitle.includes('Feet Included') ||
                (
                    this.productType === 'Cast Iron Column Radiators' &&
                    currentTitle.includes('Floor Standing')
                );
            const currentFeetType = currentHasFeet ? 'With Feet' : 'Without Feet';
            const currentPlugType = currentTitle.includes('With Plug') ? 'With Plug' : 'Without Plug';
            return this.products.find(product => {
                const title = product.title;
                let colorMatch = title.match((window.colourRegexMiddle || /(?!) /));
                if (!colorMatch) {
                    colorMatch = title.match((window.colourRegexEnd || /(?!) /));
                }
                const color = colorMatch ? colorMatch[1] : null;
                const size = this.extractSizeFromTitle(title);
                const electricSizeWattage = this.isElectricSizeWattageProduct()
                    ? this.extractElectricSizeWattageFromTitle(title)
                    : null;
                const panel = title.match(/(Single|Double) Panel/)?.[1];
                let shape = null;
                if (this.productType === 'Ladder Towel Rails') {
                    const shapeMatch = title.match(/\b(Straight|Curved)\b/i);
                    if (shapeMatch) {
                        shape = shapeMatch[1].charAt(0).toUpperCase() + shapeMatch[1].slice(1).toLowerCase();
                    }
                }
                let style = null;
                if (this.productType === 'Valves') {
                    const styleMatch = title.match(/(corner|angled|straight)/i);
                    if (styleMatch) {
                        style = styleMatch[1].charAt(0).toUpperCase() + styleMatch[1].slice(1).toLowerCase();
                    }
                }
                let magneticTowelBarStyle = null;
                if (this.productType === 'Magnetic Towel Bars') {
                    if (title.includes('Square')) {
                        magneticTowelBarStyle = 'Square';
                    } else if (title.includes('Round')) {
                        magneticTowelBarStyle = 'Round';
                    }
                }
                let wattage = null;
                if (this.productType === 'Elements') {
                    const wattageMatch = title.match(/(\d+)w/i);
                    if (wattageMatch) {
                        wattage = wattageMatch[1] + 'W';
                    }
                }
                let column = null;
                if (this.productType === 'Column Feet') {
                    const columnMatch = title.match(/(\d+ Column)/i);
                    if (columnMatch) {
                        column = columnMatch[1];
                    }
                }
                let controlType = null;
                if (title.includes('Thermostatic WIFI')) {
                    controlType = 'Thermostatic WIFI';
                } else if (title.includes('Thermostatic')) {
                    controlType = 'Thermostatic';
                } else if (title.includes('Standard')) {
                    controlType = 'Standard';
                }
                let width = null;
                if (this.productType === 'Valves') {
                    const widthMatch = title.match(/(\d+)mm/);
                    if (widthMatch) {
                        width = widthMatch[1] + 'mm';
                    }
                }
                const hasFeet =
                    title.includes('Feet Included') ||
                    (
                        this.productType === 'Cast Iron Column Radiators' &&
                        title.includes('Floor Standing')
                    );
                const feetType = hasFeet ? 'With Feet' : 'Without Feet';
                const plugType = title.includes('With Plug') ? 'With Plug' : 'Without Plug';
                const colorMatches = optionType === 'colour' ? color === value : color === currentColor;
                const sizeMatches = this.isElectricSizeWattageProduct()
                    ? optionType === 'electricSizeWattage'
                        ? electricSizeWattage === value
                        : electricSizeWattage === currentElectricSizeWattage
                    : optionType === 'size'
                        ? size === value
                        : size === currentSize;
                const panelMatches = currentPanel && panel
                    ? optionType === 'panel'
                        ? panel === value
                        : panel === currentPanel
                    : true;
                const shapeMatches = this.productType === 'Ladder Towel Rails'
                    ? optionType === 'shape'
                        ? shape === value
                        : shape === currentShape
                    : true;
                const styleMatches = this.productType === 'Valves'
                    ? optionType === 'style'
                        ? style === value
                        : style === currentStyle
                    : true;
                const magneticTowelBarStyleMatches = this.productType === 'Magnetic Towel Bars'
                    ? optionType === 'magneticTowelBarStyle'
                        ? magneticTowelBarStyle === value
                        : magneticTowelBarStyle === currentMagneticTowelBarStyle
                    : true;
                const wattageMatches = this.productType === 'Elements'
                    ? optionType === 'wattage'
                        ? wattage === value
                        : wattage === currentWattage
                    : true;
                const columnMatches = this.productType === 'Column Feet'
                    ? optionType === 'column'
                        ? column === value
                        : column === currentColumn
                    : true;
                const controlTypeMatches = optionType === 'controlType'
                    ? controlType === value
                    : controlType === currentControlType;
                const widthMatches = this.productType === 'Valves'
                    ? optionType === 'width'
                        ? width === value
                        : width === currentWidth
                    : true;
                const feetTypeMatches = optionType === 'feetType'
                    ? feetType === value
                    : feetType === currentFeetType;
                const plugTypeMatches = optionType === 'plugType'
                    ? plugType === value
                    : plugType === currentPlugType;
                return (
                    colorMatches &&
                    sizeMatches &&
                    panelMatches &&
                    shapeMatches &&
                    styleMatches &&
                    magneticTowelBarStyleMatches &&
                    wattageMatches &&
                    columnMatches &&
                    controlTypeMatches &&
                    widthMatches &&
                    feetTypeMatches &&
                    plugTypeMatches
                );
            });
        }

    productUrl(product) {
      const base = this.container.dataset.rootUrl.replace(/\/$/, '');
      return `${base}/products/${encodeURIComponent(product.handle)}`;
    }
    render(options) {
      const labels = JSON.parse(this.container.dataset.labels);
      const dimensions = [
        ['magneticTowelBarStyles','magneticTowelBarStyle','style'],
        ['colors','colour','colour'],
        [this.isElectricSizeWattageProduct() ? 'electricSizeWattages' : 'sizes',this.isElectricSizeWattageProduct() ? 'electricSizeWattage' : 'size','size'],
        ['panelTypes','panel','panel'],['shapes','shape','shape'],['styles','style','style'],
        ['wattages','wattage','wattage'],['columns','column','columns'],
        ['controlTypes','controlType','control'],['widths','width','width'],
        ['feetTypes','feetType','feet'],['plugTypes','plugType','plug']
      ];
      const fragment = document.createDocumentFragment();
      dimensions.forEach(([key,type,label]) => {
        if (!options[key] || options[key].size < 2) return;
        const group = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = labels[label];
        group.appendChild(legend);
        const links = document.createElement('div');
        links.className = 'ukr-lander-links';
        options[key].forEach(value => {
          const product = this.findProductByOptions(type,value);
          const link = document.createElement('a');
          link.textContent = value;
          if (product) {
            link.href = this.productUrl(product);
            if (product.id.split('/').pop() === this.productId) link.setAttribute('aria-current','page');
          } else { link.setAttribute('aria-disabled','true'); }
          links.appendChild(link);
        });
        group.appendChild(links); fragment.appendChild(group);
      });
      const label = document.createElement('label');
      label.textContent = labels.all_options;
      const select = document.createElement('select');
      select.className = 'ukr-lander-native';
      const placeholder = new Option(this.productTitle, '', true, true);
      select.add(placeholder);
      this.products.forEach(product => {
        const option = new Option(product.title, this.productUrl(product));
        if (product.id.split('/').pop() === this.productId) { placeholder.remove(); option.selected = true; }
        select.add(option);
      });
      select.addEventListener('change', () => { if (select.value) window.location.assign(select.value); });
      label.appendChild(select); fragment.appendChild(label);
      this.container.replaceChildren(fragment);
    }
  }
  function boot(scope = document) {
    const roots = [...scope.querySelectorAll('[data-ukr-lander]')];
    if (scope.matches?.('[data-ukr-lander]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const group = root.querySelector('.ukr-lander-group');
      if (group) new UKRLanderGroup(group);
      const variant = root.querySelector('select[name="id"]');
      variant?.addEventListener('change', () => {
        root.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.location.assign(url.href);
      });

    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
})();
